<template>
  <BaseBody>
    <BaseTopBar>
      <BaseTopBarContent className="left">
        {{ $t('sidebar.billinghistory') }}
      </BaseTopBarContent>
    </BaseTopBar>
    <BaseContent :loading="loading">
      <BaseTable
        :pagination="pagination"
        class="custom-table"
        tableClass="table-bordered"
        @onPageChange="handlePageChange"
      >
        <template #thead>
          <thead>
            <tr>
              <th>{{ $t('apps.billing.label.detail') }}</th>
              <th
                class="text-center"
                style="width: 400px;">{{ $t('apps.payment.label.ordernumber') }}</th>
              <th
                class="text-center"
                style="width: 200px;">{{ $t('apps.billing.label.paiddate') }}</th>
              <th
                class="text-right"
                style="width: 200px;">{{ $t('apps.billing.label.payamount') }}</th>
                <!-- <th style="width: 140px;" class="text-center">{{ $t('apps.billing.label.download') }}</th> -->
            </tr>
          </thead>
        </template>
        <template #tbody>
          <tbody>
            <tr>
              <td
                v-if="empty"
                colspan="5"
                class="text-center">
                {{ $t('message.notfounddata') }}
              </td>
            </tr>
            <tr
              v-for="(item, index) in transformData"
              :key="index"
            >
              <td>
                {{ item.description }}
              </td>
              <td class="text-center">
                {{ item.chargeId }}
              </td>
              <td class="text-center">
                {{ getDateCustom(item.paidAt, { format: 'YYYY-MM-DD H:m:s' }) }}
              </td>
              <td class="text-right">
                {{ getCurrencyWithNumber(numberel(item.paidAmount, '0,0.00')) }}
              </td>
              <!-- <td class="text-center">
                PDF
              </td> -->
            </tr>
          </tbody>
        </template>
      </BaseTable>
    </BaseContent>
  </BaseBody>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import tablePaginateMixin from '@/mixins/tablePaginate'
import sidebarModule from './../../sidebarModule'
import { TRANSACTION_TYPE } from '@/helpers/enum'

export default {
  mixins: [tablePaginateMixin],

  data () {
    return {
      loading: false,
      query: {
        page: this.$route.query.page || 1,
      },
    }
  },

  computed: {
    ...mapState('billing', {
      data: 'transactionList',
    }),
    empty () {
      return !this.data.length
    },
    transformData () {
      return this.data.map((item) => {
        return {
          ...item,
          description: (() => {
            if (item.type === TRANSACTION_TYPE.INVOICE) {
              return this.$t('apps.billing.message.billingmonthly')
            } else if (item.type === TRANSACTION_TYPE.BILL) {
              return item.orders.reduce((acc, cur) => {
                if (['user', 'branch', 'warehouse'].includes(cur.detail)) {
                  const patt1 = {
                    'user': this.$t('apps.billing.message.addeduser', { number: cur.quantity }),
                    'branch': this.$t('apps.billing.message.addedbranch', { number: cur.quantity }),
                    'warehouse': this.$t('apps.billing.message.addedwarehouse', { number: cur.quantity }),
                  }
                  const patt2 = {
                    'user': this.$t('apps.billing.message.addedusers', { number: cur.quantity }),
                    'branch': this.$t('apps.billing.message.addedbranches', { number: cur.quantity }),
                    'warehouse': this.$t('apps.billing.message.addedwarehouses', { number: cur.quantity }),
                  }
                  if (cur.quantity === 1) {
                    acc.push(patt1[cur.detail])
                  } else {
                    acc.push(patt2[cur.detail])
                  }
                }
                return acc
              }, []).join(', ')
            }
            return null
          })(),
        }
      })
    },
  },

  beforeMount () {
    this.initPage({
      section: 'app',
      name: this.$t('app.billing.title'),
      current: {
        app_name: 'billing',
        app_id: null,
      },
    })
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 2,
    })
  },

  mounted () {
    this.fetchData()
  },

  destroyed () {
    this.leavePage(this.$Progress, [])
  },

  methods: {
    ...mapActions('billing', {
      getTransactionList: 'getTransactionList',
    }),
    async fetchData () {
      this.updateUrl()
      this.loading = true
      await this.getTransactionList({
        page: this.query.page,
        limit: this.$store.state.app.limitRowsPerpage,
      })
      this.loading = false
      this.showFinish(this.$Progress)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/billing/history/Index.vue